export const debugConfig = {
    appId: '7be43939-ffed-4321-b74a-fc16aeac72dd',
};

export const prodConfig = {
    appId: '7be43939-ffed-4321-b74a-fc16aeac72dd',
};
